export default __webpack_public_path__ + "static/media/6-folded-hands_medium-skin-tone_1f64f-1f3fd_1f3fd.7b4e3638.png";